import React from 'react';

import './styles.css';

import { useSelector } from 'react-redux';

import SEO from '../../partials/SEO/SEO.js'
import PageHeader from '../../partials/PageHeader/PageHeader.js'
import ContactForm from '../../partials/ContactForm/ContactForm.js'

const ContactUs = props => {

    const { setting, loading, error } = useSelector((state) => state.settingStore);

    return (
        <React.Fragment>
            <SEO 
                title = {setting?.contact_us_seo_title}
                description = {setting?.contact_us_seo_description}
                keywords = {setting?.contact_us_seo_keywords}
            />
            <div role="main" className="main">
                <PageHeader title={setting?.contact_us_page_title} parentPage="Home" />
                <ContactForm setting={setting} />
            </div>
        </React.Fragment>
    );
};

export default ContactUs;
